import { useEffect, useState } from "react";
import { WorkflowStatusAction } from "../../../utilities/interfaces/WorkflowStatusAction";
import { AdvanceFiling } from "../../../utilities/interfaces/AdvanceFiling";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getWorkflowStatusActionsByStatusAndRoleIds } from "../../../features/state/StateWorkflowStatusAction-slice";
import { filingAPI } from "../../../utilities/api";
import { getAllFilingRejectReasons } from "../../../features/state/StateFilingRejectReason-slice";
import { getFilingWorkflowHistoriesByFilingId } from "../../../features/state/StateFilingWorkflowHistory-slice";
import { clearDashboardFilings } from "../../../features/state/StateFiling-slice";
import { useNotificationHelper } from "../../../utilities/helpers/NotificationHelper";

export const useStatusActionsController = (
  statusId: any,
  confirmAdvance: boolean | undefined,
  setStatusActionId: Function | undefined,
  toggleConfirmationDialog: Function | undefined,
  filingId: number,
  getStatus: Function,
) => {
  const statusActions: WorkflowStatusAction[] = useAppSelector((state) => state.workflowStatusActions.statusActions);
  const rejectReasons: any = useAppSelector((state) => state.filingRejectionReasons.value);
  const fetchingStatusActions: boolean = useAppSelector((state) => state.workflowStatusActions.fetchingStatusActions);
  const dispatch = useAppDispatch();
  const { addNotification } = useNotificationHelper();

  useEffect(() => {
    if (statusId && statusActions.length < 1) {
      getStatusActions(statusId);
    }

    if (!rejectReasons || rejectReasons.length < 1) {
      dispatch(getAllFilingRejectReasons());
    }

    calculateIsDev();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getStatusActions = async (id: number) => {
    dispatch(getWorkflowStatusActionsByStatusAndRoleIds(id));
  }

  const performAction = async (filingId: number, statusActionId: number, getStatus: Function, rejectReasonId?: number) => {
    let advanceFilingDto: AdvanceFiling = {
      filingId: filingId,
      workflowStatusActionId: statusActionId,
      rejectReasonId: rejectReasonId
    };

    try {
      let result: any = await filingAPI.advanceStatus(advanceFilingDto);

      getStatus(result);
      getStatusActions(result);
      dispatch(getFilingWorkflowHistoriesByFilingId(filingId));
      dispatch(clearDashboardFilings());
    } catch (e: any) {
      addNotification({
        type: 'error',
        message: e?.response?.data?.message ?? 'Unable to advance filing status. Make sure all required fields are filled out.',
      });
    }
  }

  const onActionClick = (statusActionId: number, rejectReasonId?: number) => {
    performAction(filingId, statusActionId, getStatus, rejectReasonId);
  }

  const promulgate = (filingId: number) => {
    filingAPI.promulgate(filingId);
  }

  const [isDevUser, setIsDevUser] = useState<boolean>(false);

  const calculateIsDev = () => {
    const roleNames: any[] = JSON.parse(sessionStorage.getItem('roles') ?? "[]");
    setIsDevUser(roleNames.includes('Dev'));
  }

  return { 
    statusActions, 
    onActionClick, 
    rejectReasons, 
    fetchingStatusActions, 
    promulgate,
    isDevUser,
  };
};